export default {
  state: {
    stats: [],
  }
};
